<template>
  <v-select
    :value="value"
    :items="options"
    :loading="loading"
    item-text="name"
    item-value="id"
    label="Коннекторы"
    style="border-radius: 10px; max-width: 480px;"
    background-color="#fff"
    height="40"
    multiple
    hide-details
    flat
    solo
    @input="$emit('input', $event)"
  >
    <template #prepend-inner>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="#FF9D00"
            v-bind="attrs"
            v-on="on"
          >
            {{ prependIcon }}
          </v-icon>
        </template>
      </v-tooltip>
    </template>
    <template v-if="options.length" #prepend-item>
      <v-list-item @click="toggleAll">
        <v-list-item-action>
          <v-checkbox
            :indeterminate="someSelected && !allSelected"
            :input-value="allSelected"
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Все коннекторы
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>

    <template #item="{ item, attrs, on }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-action>
          <v-checkbox :input-value="attrs.inputValue" hide-details class="ma-0 pa-0"></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template #selection="{ item, index }">
      <template v-if="allSelected">
        <span v-if="index === 0" class="align-self-center">
          Все коннекторы
        </span>
      </template>
      <template v-else>
        <v-chip v-if="index < 2" small>
          <span>{{ item.name }}</span>
        </v-chip>
        <span
          v-if="index === 2"
          class="grey--text text-caption align-self-center"
        >
          (+{{ value.length - 2 }} других)
        </span>
      </template>
    </template>
  </v-select>
</template>

<script>
  import connectorsReferenceApi from '@/api/statistics/connectors/reference'

  export default {
    name: 'ConnectorSelect',
    props: {
      value: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        options: [],
        loading: false,
      }
    },
    computed: {
      prependIcon () {
        if (this.allSelected) return 'mdi-check-all'
        if (this.someSelected) return 'mdi-check'
        return 'mdi-circle-outline'
      },
      allSelected () {
        return this.options.length > 0 && this.value.length === this.options.length
      },
      someSelected () {
        return this.value.length > 0 && !this.allSelected
      },
    },
    created () {
      this.loadConnectors()
    },
    methods: {
      async loadConnectors () {
        this.loading = true

        try {
          const response = await connectorsReferenceApi.fetchConnectors()
          this.options = response.items
          this.toggleAll()
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.loading = false
      },
      toggleAll () {
        this.$emit('input', this.allSelected ? [] : this.options.map((item) => item.id))
      },
    },
  }
</script>
